import React, { useRef } from "react";
import { useDispatch } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';

import { globalStatistic } from "../../redux/actions/otherActions";
import SmartLink from '../../components/SmartLink';

const BlockBannerItem = ({ item, key }) => {

    const mouseMoved = useRef(false);
    const dispatch = useDispatch();
    const minWidth820 = useMediaQuery('(min-width: 820px)');

    const handleClick = (event) => {
        if (mouseMoved.current) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            dispatch(globalStatistic(item.anBannerOrgId, 'BANNER'));
        }
    };
    var slide = minWidth820 ? item.acBannerImage : item.acFilenameMobile;

    return (
        <div className="banner-block-home-item" key={key}>
            <SmartLink
                to={item.acBannerLink}
                isNewTabOpen={item.isNewTabOpen}
                onMouseMove={() => { mouseMoved.current = true; }}
                onMouseDown={() => { mouseMoved.current = false; }}
                onClick={handleClick}
            >
                <img src={`https://resource.ewe.rs/media/${slide}`} className="slider-image-home-block" alt={`${item.acSeoDescription}`} title={`${item.acSeoTitle}`} />
                {/* <div className="banner-item-block-image" style={{backgroundImage: `url(http://www.ewe.rs/media/${item.acBannerImage})`}}></div> */}
            </SmartLink>
        </div>
    );

};

export default BlockBannerItem;
